"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.providersSync = void 0;
const rows = require('../../../../../../../data/sheets/providers.json');
const store_1 = require("../../../../providers/store");
const store_2 = require("../../../../sites/modules/sites-list/store");
exports.providersSync = () => {
    const skipRows = [1, 2, 3]; // Hardcoded rows to skip.
    const { sites: { value: sites = [] } } = store_2.sitesListStore;
    const sitesMap = sites.map((site, i) => site.displayName);
    return Promise.all(Object.values(rows.providers).map(async (row, i) => {
        const provider = {
            email: '',
            firstName: '',
            lastName: '',
            id: 0,
            phone: '',
            dea: '...',
            deaExp: new Date(),
            notes: '',
            npiNumber: '...',
            signature: '',
            sites: [],
            state: 'SC',
            stateLicense: '...',
            stateLicenseExp: new Date(),
            title: 'MD',
        };
        if (row.name && skipRows.indexOf(i + 1) === -1) {
            const fullName = row.name.split(' ');
            provider.firstName = fullName[0] === 'Dr.' ? fullName[1] : fullName[0];
            switch (true) {
                case fullName[0] === 'Dr.' && fullName.length === 2:
                    provider.lastName = '';
                    break;
                case fullName[0] !== 'Dr.' && fullName.length === 2:
                    provider.lastName = fullName[1];
                    break;
                default:
                    provider.lastName = fullName[2];
                    break;
            }
            // clinic assignments here
            row.clinic &&
                row.clinic
                    .replace(/&/g, '')
                    .replace(/,/g, '')
                    .replace(/s+/g, ' ')
                    .split(' ')
                    .forEach((clinic) => {
                    if (sites[sitesMap.indexOf(clinic)]) {
                        clinic && provider.sites.push(sites[sitesMap.indexOf(clinic)]);
                    }
                });
            provider.lastName = !provider.lastName ? '...' : provider.lastName;
            provider.email = row.email;
            provider.phone = row.phone;
            return store_1.providersStore.createProvider(provider);
        }
        return null;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sync/modules/google-sync/modules/google-providers.ts
// module id = 4142
// module chunks = 0